import { MapContainer, TileLayer, CircleMarker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

function ClickPick({ onPick }) {
  useMapEvents({ click: (e) => onPick(e.latlng.lat.toFixed(6), e.latlng.lng.toFixed(6)) });
  return null;
}

// Koordinat hanya terisi bila diketik / diklik pengguna. Pusat peta hanya tampilan.
export function CoordFields({ lat, lng, onChange, viewCenter }) {
  const has = lat !== "" && lng !== "" && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng));
  const center = has ? [Number(lat), Number(lng)] : viewCenter;
  return (
    <div className="space-y-2" data-testid="coord-fields">
      <div className="grid grid-cols-2 gap-2">
        <div><Label>Latitude</Label>
          <Input value={lat} onChange={(e) => onChange(e.target.value, lng)} placeholder="Kosong = belum diketahui"
                 data-testid="coord-lat" /></div>
        <div><Label>Longitude</Label>
          <Input value={lng} onChange={(e) => onChange(lat, e.target.value)} placeholder="Kosong = belum diketahui"
                 data-testid="coord-lng" /></div>
      </div>
      {!center ? (
        <p className="rounded border border-dashed p-3 text-xs text-[#6B7280]" data-testid="coord-map-hidden">
          Peta bantu tampil setelah memilih Lokasi kantor yang memiliki koordinat. Koordinat tetap bisa diketik manual.</p>
      ) : (
      <div className="h-44 overflow-hidden rounded-md border border-[#E5E7EB]">
        <MapContainer key={has ? "has" : "none"} center={center} zoom={has ? 16 : 12} style={{ height: "100%", width: "100%" }}>
          <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <ClickPick onPick={onChange} />
          {has && <CircleMarker center={center} radius={8} pathOptions={{ color: "#0055FF", fillOpacity: 0.8 }} />}
        </MapContainer>
      </div>
      )}
      <div className="flex items-center justify-between text-xs text-[#6B7280]">
        <span>Klik peta untuk mengisi koordinat. Biarkan kosong bila belum diketahui.</span>
        {has && <Button type="button" variant="ghost" size="sm" onClick={() => onChange("", "")} data-testid="coord-clear">Kosongkan</Button>}
      </div>
    </div>
  );
}
